import { render } from "./ArchiveTerm.vue?vue&type=template&id=4381246a&scoped=true"
import script from "./ArchiveTerm.vue?vue&type=script&lang=js"
export * from "./ArchiveTerm.vue?vue&type=script&lang=js"

import "./ArchiveTerm.vue?vue&type=style&index=0&id=4381246a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4381246a"]])

export default __exports__